import { useState } from 'react'

import { RequestStatus, type ServerError } from 'core/domain/Request'
import { type HttpClientError } from 'core/infra/http/HttpClient'

import { sentry } from 'legacy/utils/sentry'

import { type Driver } from '../../domain/Driver'
import { createDriver } from '../../use-cases/createDriver'

export function useCreateDriver() {
  const [createDriverStatus, setCreateDriverStatus] = useState(RequestStatus.Initial)
  const [createDriverErrors, setCreateDriverErrors] = useState<ServerError | undefined>()

  async function createDriverFn(driver: Driver) {
    try {
      setCreateDriverStatus(RequestStatus.Pending)
      setCreateDriverErrors(undefined)

      const newDriver = await createDriver(driver)

      setCreateDriverStatus(RequestStatus.Done)

      return newDriver
    } catch (error) {
      setCreateDriverStatus(RequestStatus.Error)
      setCreateDriverErrors((error as HttpClientError<ServerError>).response?.data)

      sentry.log(error)

      throw new Error('Could not create the driver', { cause: error as Error })
    }
  }

  return { createDriver: createDriverFn, createDriverStatus, createDriverErrors }
}
